var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"y-fl-footer h_footer"},[_c('el-row',{attrs:{"align":"middle"}},[_c('el-col',{staticClass:"fl-footer-icon-ctr",staticStyle:{"text-align":"right"}},[_c('i',{staticClass:"el-icon-lock"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }